import { apiClient } from './client.js';

export const tagsApi = {
  list: (entityType, q = '') =>
    apiClient.get('/tags', { params: { entity_type: entityType, q } }),
};
